import { render, staticRenderFns } from "./PatientSmsPanel.vue?vue&type=template&id=8f51b426&scoped=true"
import script from "./PatientSmsPanel.vue?vue&type=script&lang=js"
export * from "./PatientSmsPanel.vue?vue&type=script&lang=js"
import style0 from "./PatientSmsPanel.vue?vue&type=style&index=0&id=8f51b426&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f51b426",
  null
  
)

export default component.exports